import { call, put, select, takeLatest } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelperV2'
import {
  updateHomeData,
  updateHomeError,
  updateHomeIsLoading,
  setIsEditingSpeedFormation,
  updateSpeedFormationSaveStatus,
} from '@/containers/HomePage/HomeSlice'
import { selectHomeData } from '@/containers/HomePage/HomeSelectors'

export const homeActions = {
  INITIALIZE_HOME: 'INITIALIZE_HOME',
  SAVE_SPEED_FORMATION: 'SAVE_SPEED_FORMATION',
}

export function* initializeHomeSaga({ endpoint }) {
  try {
    yield put(updateHomeIsLoading(true))

    const data = yield call(callApi, { endpoint })

    yield put(updateHomeData(data))
  } catch (error) {
    yield put(updateHomeError(error.message))
  } finally {
    yield put(updateHomeIsLoading(false))
  }
}

export function* saveSpeedFormationSaga({ text, date }) {
  try {
    yield put(updateSpeedFormationSaveStatus({ isLoading: true, error: null, errorMessage: null }))

    const data = yield select(selectHomeData)
    const endpoint = data.editSpeedFormationUrl ?? ''

    yield call(callApi, {
      endpoint,
      method: 'POST',
      payload: { speed_training_text: text, speed_training_end_date: date },
    })

    yield put(updateHomeData({ ...data, speedFormation: { text, date } }))
    yield put(updateSpeedFormationSaveStatus({ isLoading: false, error: false, errorMessage: null }))
    yield put(setIsEditingSpeedFormation(false))
  } catch (error) {
    yield put(updateSpeedFormationSaveStatus({ isLoading: false, error: true, errorMessage: error.message }))
  }
}

export default function* homeSagas() {
  yield takeLatest(homeActions.INITIALIZE_HOME, initializeHomeSaga)
  yield takeLatest(homeActions.SAVE_SPEED_FORMATION, saveSpeedFormationSaga)
}
